import { FC } from "react";
import { useTranslation } from "react-i18next";

interface CustomErrorProps {
    errorKey: string;
    name: string;
}

const CustomError: FC<CustomErrorProps> = (props) => {
    const { t } = useTranslation();

    const isTranslationKey = typeof props.errorKey === "string" && props.errorKey.startsWith("errors.");

    return (
        <p className={`mt-1 ml-3 text-sm font-normal text-red-500`}>
            {props.errorKey ? (isTranslationKey ? t(props.errorKey) : props.errorKey) : props.name ? "\u00A0" : ""}
        </p>
    );
};

export default CustomError;
